/* Atelier - buy box: show personalisation UI only on products that have it.

   The file-upload app block is added to the product template, so it renders on all 178
   products whether or not that product is configured in the app. Measured:

     cat-shape-customized-photo-necklace   #photouploadapp has 2 children, 2 controls
     hugging-necklace                      #photouploadapp has 0 children, 0 controls

   The theme cannot ask the app which products are configured, so it reads the rendered
   result: a personalisation block with no control in it is an empty block.

   This used to run the other way round - show everything, then hide what turned out to be
   empty after a three second grace period - and the merchant saw exactly what that implies:
   "Personalise this piece" appearing for a second or two on every product and then
   vanishing. Showing something and taking it away is worse than never showing it.

   So the block now starts hidden, from a stylesheet rule that applies at first paint, and is
   revealed the moment a control appears. The guard class that enables that rule is set in
   sections/atelier-pdp.liquid, which also lifts it if this file never runs - a script that
   fails to load must not be able to hide a working upload field.

   The control test is structural, not visual. An earlier version asked whether a control was
   rendered, using offsetParent - which is null for everything inside a display:none block.
   The block was hidden, so no control could ever look visible, so it was never revealed: the
   upload field disappeared from the products that actually have one. */
(function () {
  'use strict';

  /* Read by the inline guard in sections/atelier-pdp.liquid. */
  window.__atelierBuybox = true;

  var personaliseTemplate = null;

  function visible(el) {
    return el.offsetParent !== null || el.getClientRects().length > 0;
  }

  /* Does the app actually have something for this product? Asked of the markup, because the
     block this looks inside is hidden until the answer is yes. */
  function hasControl(root) {
    if (root.querySelector('.uploadcare--widget__button')) return true;
    if (root.querySelector('input[type="file"]')) return true;

    var mount = root.querySelector('#photouploadapp');
    if (mount && mount.children.length > 0) return true;

    return !!root.querySelector('input:not([type="hidden"]), textarea, select, button');
  }

  function isPersonalisationBlock(el) {
    return /upload|personali[sz]/i.test(el.id + ' ' + (el.textContent || ''));
  }

  /* Covers personalisation delivered as a line item property rather than as an app block -
     an engraving box added to the template, for instance.

     Scoped to the add-to-cart form and to names beginning with properties[, because a plain
     "any visible text input in the buy column" test picks up Dawn's own Share URL field,
     which is a text input 276px wide sitting inside the share popover. That false positive
     kept the Personalise it claim on every product in the catalogue.

     These fields are not inside the guarded block, so here the visibility test is sound. */
  function hasPropertyFields(info) {
    var form = info.querySelector('form[action*="/cart/add"]')
            || document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return false;

    var list = form.querySelectorAll('input[type="file"], input[type="text"], textarea, select');
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      if (!/^properties\[/.test(n.name || '')) continue;
      if (visible(n)) return true;
    }
    return false;
  }

  function setTrust(live) {
    var row = document.querySelector('.gf-pdp-trust');
    if (!row) return;

    if (!personaliseTemplate) {
      personaliseTemplate = document.querySelector('[data-trust-template="personalise"]');
    }

    var cell = row.querySelector('[data-trust="personalise"]');

    if (live && !cell && personaliseTemplate) {
      row.appendChild(personaliseTemplate.content.cloneNode(true));
    } else if (!live && cell) {
      cell.remove();
    }

    /* The stylesheet sizes the grid from this, because the item count is not fixed. */
    row.setAttribute('data-trust-count', String(row.children.length));
  }

  function scan() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var live = hasPropertyFields(info);

    [].forEach.call(info.querySelectorAll('.shopify-app-block'), function (block) {
      if (!isPersonalisationBlock(block)) return;

      if (hasControl(block)) {
        block.setAttribute('data-atelier-ready', '');
        live = true;
      } else {
        block.removeAttribute('data-atelier-ready');
      }
    });

    setTrust(live);
  }

  function watch() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        scan();
      }, 160);
    }).observe(info, { childList: true, subtree: true });
  }

  function init() {
    scan();
    watch();
    /* The app injects late and in stages. No grace period is needed any more: nothing is
       showing that these passes could take away. */
    [400, 1200, 3000, 6000, 10000].forEach(function (ms) {
      window.setTimeout(scan, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();